// packages import
import { Box } from "@mui/material";
import { Reducer, useContext, useEffect, useReducer, useState } from "react";
// component import
import { ContentHead } from "../../../components/common/ContentHead";
import { EmptyData } from "../../../components/common/EmptyData";
import { AddNewLawType } from "../../../components/lawType/AddNewLawType";
import { DeleteLawType } from "../../../components/lawType/DeleteLawType";
import { LawTypeListing } from "../../../components/lawType/LawTypeListing";
import { LawTypeAction, lawTypeInitialState, lawTypeReducer, LawTypeState } from "../../../components/lawType/LawTypeReducer";
import { ViewCurrentLawType } from "../../../components/lawType/ViewCurrentLawType";
// others
import { LawTypesPayload, useFetchAllLawTypesLazyQuery } from "../../../../generated";
import { GRAPHQL_QUERY_POLICY } from "../../../constants";
import { AuthContext } from "../../../context";
import { CardBox } from "../../../theme/styleComponents";
import { flexCenter } from "../../../theme/styleConstants";

export const LawType = () => {
  const [allLawTypes, setAllLawTypes] = useState<LawTypesPayload['lawTypes']>()
  const { isAdmin } = useContext(AuthContext)
  const [lawTypeState, lawTypeDispatch] = useReducer<Reducer<LawTypeState, LawTypeAction>>(lawTypeReducer, lawTypeInitialState)

  const [fetchAllLawTypes, { loading, refetch }] = useFetchAllLawTypesLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,

    onError() {
      setAllLawTypes([])
    },

    onCompleted(data) {
      if (data) {
        const { fetchAllLawTypes } = data

        if (fetchAllLawTypes) {
          const { lawTypes } = fetchAllLawTypes || {}
          setAllLawTypes(lawTypes || [])
        }
      }
    }
  })

  useEffect(() => {
    fetchAllLawTypes()
    // eslint-disable-next-line
  }, [])

  const isEmpty = !loading && allLawTypes && allLawTypes?.length === 0

  return (
    <>
      <CardBox marginTop={3}>
        <ContentHead title='Law Type' buttonText={isAdmin ? 'Create' : ''} />

        {isEmpty ?
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 255px)' }}>
            <EmptyData title={"No law type found"} />
          </Box>
          :
          <LawTypeListing loading={loading} allLawTypes={allLawTypes} dispatch={lawTypeDispatch} />
        }
      </CardBox>

      <AddNewLawType refetch={refetch} />
      <DeleteLawType refetch={refetch} state={lawTypeState} dispatch={lawTypeDispatch} />
      <ViewCurrentLawType state={lawTypeState} dispatch={lawTypeDispatch} refetch={refetch} loading={loading} />
    </>
  );
}